module.exports = __webpack_public_path__ + "62696587c4ed00ba06bd024ec09fa20a.MP3";